// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-button_iconButton__R1bpM {\r\n  background-color: transparent;\r\n  border: none;\r\n  display: inline-block;\r\n}\r\n", "",{"version":3,"sources":["webpack://./src/components/ui/IconButton/icon-button.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,YAAY;EACZ,qBAAqB;AACvB","sourcesContent":[".iconButton {\r\n  background-color: transparent;\r\n  border: none;\r\n  display: inline-block;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconButton": "icon-button_iconButton__R1bpM"
};
export default ___CSS_LOADER_EXPORT___;
